import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['form']

    submit(event) {
        event.preventDefault();
        this.formTarget.requestSubmit()
    }

    sendRequest(event) {
        let token = document.querySelector('meta[name="csrf-token"]').content
        let url = event.target.dataset.url
        let fieldName = event.target.value
        let scopeName = event.target.dataset.scopeName
        fetch(url, {
            method: "PATCH",
            headers: {
                "X-CSRF-Token": token,
                "Content-Type": "application/json",
                "Accept": "text/vnd.turbo-stream.html"
            },
            body: JSON.stringify({
                [scopeName]: {
                    field: fieldName

                },
            }),
        })
            .then((response) => response.text())
            .then((html) => {
                Turbo.renderStreamMessage(html)
            })

    }

    sendGetRequest(event) {
        let token = document.querySelector('meta[name="csrf-token"]').content;
        let url = new URL(event.target.dataset.url, window.location.origin);
        let fieldName = event.target.value;
        url.searchParams.append(`field`, fieldName);

        let acceptType = event.target.dataset.requestType === "html" ? "text/html" : "text/vnd.turbo-stream.html";
        fetch(url, {
            method: "GET",
            headers: {
                "X-CSRF-Token": token,
                "Accept": acceptType,
            },
        })
            .then((response) => response.text())
            .then((html) => {
                // Render the Turbo Stream or HTML response
                Turbo.renderStreamMessage(html);

                // Close the Tom Select dropdown manually
                let tomSelectInstance = event.target.tomselect;
                if (tomSelectInstance) {
                    tomSelectInstance.close();
                }
            });
    }


}
